import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CompanyConfigUrlsQuery, CompanyConfigUrlsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CompanyConfigUrlsQuery)
@Wrapper(CompanyConfigUrlsQueryHandlerBase)
export class CompanyConfigUrlsQueryHandler {
    public constructor(
        http: Http
    ) { }
}
